import { withInstall } from '@vuesax-plus/utils'
import Col from './src/col.vue'

export const VsCol = withInstall(Col)
export default VsCol

export * from './src/col'
